import { RootState } from "@stores/store";
import { useSelector } from "react-redux";
import createStore from "teaful";
import { Template as TableTemplate } from "types/template";

interface Attribute {
  id: number;
  type: "KEY_VALUE" | "PRINT_CARE" | "SIZE_EXPRESSION";
  key?: string;
  name: string;
  value: any;
}

interface Template extends TableTemplate {
  cost: string;
  images: any[];
  wholesale_group: any;
  category: any;
  initAreas: any[];
  recommends: any[];
  files: any[];
  colors: any[];
  options: any[];
  sizes: any[];
  shipping_rates: any[];
  attributes: Attribute[];
  review: {
    score: number;
    quantity: number;
    resume: [number, number, number, number, number];
  } | null;
}

type TemplateStore = {
  template: Template;
  activeCountryCode: string;
  activeShippingRate: any;
  activeShippingProfileID: number;
  isSwitchModalOpen: boolean;
  isBigOrderInquireModelOpen: boolean;
};

export const { useStore: useContainer } = createStore<TemplateStore>();

export const useTemplate = () =>
  useSelector((store: RootState) => store.template.template);

export const useActiveColorId = (): number | null =>
  useSelector((store: RootState) => store.template.activeColorId);
